// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
var firebaseConfig = {
  apiKey: "AIzaSyBYn8S1rj2ufioBij19y4H_f2e6n0mC38g",
  authDomain: "life-lesson-share-app.firebaseapp.com",
  databaseURL: "https://life-lesson-share-app-default-rtdb.firebaseio.com",
  projectId: "life-lesson-share-app",
  storageBucket: "life-lesson-share-app.appspot.com",
  messagingSenderId: "537700047745",
  appId: "1:537700047745:web:937423571ace7fe3c9e680",
  measurementId: "G-VZMYL084VX",
  useFirestoreForProfile: true 
};
  firebase.initializeApp(firebaseConfig)
  firebase.firestore().settings({timestampsInSnapshots: true})
  export default firebase